// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.91.0-beta.e3886530b',
  revision: 'e3886530b',
  branch: 'develop',
  date: 'Wed, 30 Sep 2026 14:06:57 GMT'
};